var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Module, ModuleGrid, ModuleLink, ModuleHeader, ModuleBody, ModuleFooter, ModuleAvatar, ModuleAuthor, ModuleCount, ModuleSubject, ModuleMessage, ModuleDate, AttachmentModule } from "../";

import { InboxModuleLabel, InboxModuleIcon, InboxModuleAuthors } from '../';
import { getUrlFromProps } from "../../resources/functions/";

import "./InboxModule.scss";
import "./InboxModule--Small.scss";
import "./InboxModule--Large.scss";
import "./InboxModule--XL.scss";

import Turndown from "turndown";

var turndown = new Turndown({
    headingStyle: "atx",
    bulletListMarker: "-"
});

var InboxModule = (_temp2 = _class = function (_Component) {
    _inherits(InboxModule, _Component);

    function InboxModule() {
        var _temp, _this, _ret;

        _classCallCheck(this, InboxModule);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getMessage = function (message) {
            var html = document.createElement("div");
            html.innerHTML = message;

            var text = html.textContent || html.innerText || message;

            var markdown = message;

            if (message) {
                markdown = turndown.turndown(message);
            }

            return {
                text: text,
                markdown: markdown
            };
        }, _this.getPreview = function () {
            var _this$props = _this.props,
                inboxType = _this$props.inboxType,
                title = _this$props.title,
                messages = _this$props.messages,
                messagesCount = _this$props.messagesCount,
                uniqueId = _this$props.uniqueId;

            // url

            var url = getUrlFromProps(_this.props);

            // messages

            var count = parseInt(messagesCount) || parseInt(messages.length);

            if (count < 2) {
                count = undefined;
            }

            // first message

            var m1 = messages[0];
            var author = m1.author,
                subject = m1.subject,
                message = m1.message;

            var _this$getMessage = _this.getMessage(message),
                text = _this$getMessage.text,
                markdown = _this$getMessage.markdown;

            // from

            return _extends({}, _this.props, {
                url: url,
                author: author,
                messagesCount: count,
                subject: subject || title,
                message: text
            });
        }, _this.renderAttachment = function (attachment, index) {
            var _this$props2 = _this.props,
                inboxType = _this$props2.inboxType,
                messages = _this$props2.messages,
                messagesCount = _this$props2.messagesCount;


            var commentCount = undefined;

            if (inboxType === "comments") {
                commentCount = parseInt(messagesCount) || parseInt(messages.length);
            }

            return React.createElement(AttachmentModule, _extends({}, attachment, { moduleSize: 'small', commentCount: commentCount }));
        }, _this.renderAttachments = function () {
            var attachments = _this.props.attachments;


            if (!attachments.length) {
                return false;
            }

            return React.createElement(
                'div',
                { className: 'admin-module__attachments' },
                attachments.map(_this.renderAttachment)
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    InboxModule.prototype.render = function render() {
        var _getPreview = this.getPreview(),
            moduleType = _getPreview.moduleType,
            moduleSize = _getPreview.moduleSize,
            url = _getPreview.url,
            author = _getPreview.author,
            authors = _getPreview.authors,
            messagesCount = _getPreview.messagesCount,
            subject = _getPreview.subject,
            message = _getPreview.message,
            messages = _getPreview.messages;

        return React.createElement(
            Module,
            { moduleType: moduleType, moduleSize: moduleSize, moduleShadow: false },
            React.createElement(
                ModuleGrid,
                { moduleType: moduleType },
                React.createElement(
                    ModuleLink,
                    { url: url },
                    React.createElement(
                        ModuleHeader,
                        null,
                        React.createElement(ModuleAvatar, author),
                        React.createElement(InboxModuleIcon, this.props),
                        React.createElement(InboxModuleAuthors, { messages: messages }),
                        React.createElement(ModuleCount, { count: messagesCount })
                    ),
                    React.createElement(
                        ModuleBody,
                        null,
                        React.createElement(InboxModuleLabel, this.props),
                        React.createElement(ModuleSubject, { subject: subject }),
                        React.createElement(ModuleMessage, { message: message })
                    ),
                    React.createElement(ModuleDate, this.props)
                )
            ),
            this.renderAttachments()
        );
    };

    return InboxModule;
}(Component), _class.defaultProps = {
    urlPattern: '/inbox/:uniqueId',
    moduleType: "inbox",
    moduleSize: "large",
    appName: "app",
    appColor: undefined,
    ownerName: undefined,
    ownerColor: undefined,
    inboxType: undefined,
    createdAt: "",
    updatedAt: "",
    attachments: [],
    messagesCount: undefined,
    messages: [{
        author: {
            name: "KulturIt"
        },
        subject: "Message subject",
        message: "Message body"
    }]
}, _temp2);


export default InboxModule;